import React from 'react'

const TrashCanIcon = props => (
  <svg height="512pt" viewBox="-76 0 512 512" width="512pt" {...props}>
    <path d="m25 512h310v-312h-310zm210-272h30v212h-30zm-70 0h30v212h-30zm-70 0h30v212h-30zm0 0" />
    <path d="m280 61h-35v-61h-130v61h-35c-28.300781 0-51.667969 21.484375-54.667969 49h309.332031c-2.996093-27.515625-26.363281-49-54.664062-49zm-65 0h-70v-31h70zm0 0" />
    <path d="m0 140h360v30h-360zm0 0" />
  </svg>
)

export default TrashCanIcon



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/trashCan.js